export default __webpack_public_path__ + "static/29-1a4f914a92c977dd17ccb9930f9cc8b5.png";